import { css } from '@emotion/css';
import React from 'react';
import { useLivingBundleEntitlement, usePlusRentEntitlement } from '../../../customHooks/useGetHasProduct.hook';
import { GRAY200 } from '../../../domain/colors';
import { campaigns } from '../../common/campaigns';
import { useIntl } from '@/i18n';
import { PlusBadge } from '@/components/common/display/plusBadge/PlusBadge';

const styles = {
  container: css`
    align-items: center;
    display: flex;
    padding: 16px;
    width: 100%;
    background: ${GRAY200};
    flex-wrap: nowrap;
  `,
  bannerText: css`
    margin-left: 12px;
    font-size: 16px;
  `,
  plusBadgeHeight: css`
    font-size: 24px;
  `,
};

export const LivingPlusBanner = () => {
  const { t } = useIntl();
  const isEntitledPlusRent = usePlusRentEntitlement();
  const isEntitledLivingPlus = useLivingBundleEntitlement();
  const showPlusBanner = !isEntitledLivingPlus && isEntitledPlusRent;

  if (!showPlusBanner) return null;

  return (
    <div className={`${styles.container} margin-vertical-xxl`} data-testid='livingPlusBanner'>
      <div className={styles.plusBadgeHeight}>
        <PlusBadge variant='living' />
      </div>
      <div className={styles.bannerText}>
        {t(
          {
            id: 'livingPlusBanner.description',
            defaultMessage: 'Mit WohnenPlus hast du mehr als nur ein neues Zuhause – du hast Sicherheit',
          },
          {
            WohnenPlusLink: <a href={campaigns.UPSELL_BANNER}>{'Wohnen+'}</a>,
          },
        )}
      </div>
    </div>
  );
};
